export default __webpack_public_path__ + "static/media/primary.b70d2d1d7423f57f4ee5c2a55c679c93.svg";